module.exports = __webpack_public_path__ + "static/media/doc.b65325d9.svg";